import { Map, Record } from 'immutable';

import { SimulationResultEntity } from '../components/subscription-simulator/simulation-result.entity';
import { ColumnConfigItemEntity } from '../domain/column-config-item.entity';
import { ColumnModelItemEntity } from '../domain/column-model-item.entity';
import { FilterModelItemEntity } from '../domain/filter-model-item.entity';
import { ProfileItemEntity } from '../domain/profile-item.entity';
import { PublicMetadataEntity } from '../domain/public-metadata.entity';
import { SubscriptionStatus } from '../domain/subscription.types';

export const SubscriptionSimulatorSliceKey = 'simulator';

interface ISubscriptionSimulatorSliceState {
	loading: boolean;
	preSelectedProfile: string;
	preSelectedColumnModel: string;
	simulationSubscriptionId: number;
	subscriptionStatus: SubscriptionStatus;
	simulationMetadata: PublicMetadataEntity;
	subscriptionColumns: Map<string, ColumnConfigItemEntity>;
	profilesForSimulation: Map<string, ProfileItemEntity>;
	columnModelsForSimulation: Map<string, ColumnModelItemEntity>;
	filterModelsForSimulation: Map<string, FilterModelItemEntity>;
	simulationData: SimulationResultEntity | null;
}

const simulatorDefaults: ISubscriptionSimulatorSliceState = {
	loading: false,
	preSelectedProfile: '',
	preSelectedColumnModel: '',
	simulationSubscriptionId: -1,
	subscriptionStatus: SubscriptionStatus.Unknown,
	simulationMetadata: PublicMetadataEntity.build(),
	subscriptionColumns: Map(),
	profilesForSimulation: Map(),
	columnModelsForSimulation: Map(),
	filterModelsForSimulation: Map(),
	simulationData: null,
};

export class SubscriptionSimulatorSliceState extends Record<ISubscriptionSimulatorSliceState>(
	simulatorDefaults
) {
	public setLoading(val: boolean): SubscriptionSimulatorSliceState {
		return this.set('loading', val);
	}

	public setPreSelectedProfile(
		profile: string
	): SubscriptionSimulatorSliceState {
		return this.set('preSelectedProfile', profile);
	}

	public setPreSelectedColumnModel(
		columnModel: string
	): SubscriptionSimulatorSliceState {
		return this.set('preSelectedColumnModel', columnModel);
	}

	public setSimulationSubscription(
		val: number,
		status: SubscriptionStatus,
		metadata: PublicMetadataEntity
	): SubscriptionSimulatorSliceState {
		return this.set('simulationSubscriptionId', val)
			.set('subscriptionStatus', status)
			.set('simulationMetadata', metadata);
	}

	public setSubscriptionColumns(
		val: Map<string, ColumnConfigItemEntity>
	): SubscriptionSimulatorSliceState {
		return this.set('subscriptionColumns', val);
	}

	public setProfilesForSimulation(
		val: Map<string, ProfileItemEntity>
	): SubscriptionSimulatorSliceState {
		return this.set('profilesForSimulation', val);
	}

	public setColumnModelsForSimulation(
		val: Map<string, ColumnModelItemEntity>
	): SubscriptionSimulatorSliceState {
		return this.set('columnModelsForSimulation', val);
	}

	public setFilterModelsForSimulation(
		val: Map<string, FilterModelItemEntity>
	): SubscriptionSimulatorSliceState {
		return this.set('filterModelsForSimulation', val);
	}

	public setSimulationData(
		val: SimulationResultEntity | null
	): SubscriptionSimulatorSliceState {
		return this.set('simulationData', val);
	}
}
